<template>
  <div class="app-settings-main">
    <hr />
    <p>Próbne udoje</p>
    <hr />
    <p>Data najnowszych dodanych statystyk: {{ lastStatsDate }}</p>
    <p>Wprowadź źródło strony zawierającej statystyki.
      <a target="_blank" href="https://hodowcy.zetosoftware.pl/Hodowcy/firstpage.jsp?user=00001051&pass=mucka123">Link do logowania</a>
    </p>

    <el-input type="textarea" v-model="source"></el-input>
    <el-button type="primary" class="btn" @click="sendNewStats()" :disabled="source==''" :loading="buttonLoading">Prześlij źródło strony</el-button>

    <hr />
    <drugs-table></drugs-table>
    <hr />

    <hr />

    <groups-table></groups-table>
    <hr />
  </div>
</template>

<script>
import axios from "axios";
import { serverAddress } from "../config";
import GroupsTable from "@/components/GroupsTable";
import DrugsTable from "@/components/DrugsTable";

export default {
  data: function() {
    return {
      source: "",
      buttonLoading: false,
      lastStatsDate: ""
    };
  },
  mounted: function() {
    axios
      .get(serverAddress + "/api/stats/lastmonth", {
        auth: {
          username: "foo",
          password: "bar"
        }
      })
      .then(
        function(response) {
          console.log(response);
          this.lastStatsDate = response.data;
        }.bind(this)
      )
      .catch(function(error) {
        console.log(error);
      });
  },
  methods: {
    getLastStats() {
      this.$message({
        type: "success",
        message: "Pomyślnie zapisano ustawienia"
      });
    },
    sendNewStats() {
      this.buttonLoading = true;

      var formData = new FormData();

      formData.append("source", this.source);

      axios
        .post(serverAddress + "/api/stats/parse", formData, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.$message({
              type: "success",
              message: "Pomyślnie przesłano statystyki"
            });
            console.log(response);
            this.buttonLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
            this.buttonLoading = false;
            this.$message({
              type: "error",
              message: "Błąd przesyłania statystyk."
            });
          }.bind(this)
        );
    }
  },
  components: {
    GroupsTable,
    DrugsTable
  }
};
</script>

<style>

</style>
